module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(1);

__webpack_require__(2);

var _markdownItRegex = __webpack_require__(3);

var _emoji = __webpack_require__(4);

var _emoji2 = _interopRequireDefault(_emoji);

var _fontAwesomeIconChars = __webpack_require__(5);

var _fontAwesomeIconChars2 = _interopRequireDefault(_fontAwesomeIconChars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconsPlugin = function iconsPlugin(md, name) {
  var options = null;
  switch (name) {
    case 'emoji':
      var emojis = [];
      Object.keys(_emoji2.default).forEach(function (key) {
        emojis = emojis.concat(_emoji2.default[key].shortname.slice(1, -1)).concat(_emoji2.default[key].shortname_alternates.map(function (item) {
          return item.slice(1, -1);
        }));
      });
      var emojiRegex = new RegExp('(:(?:' + emojis.join('|').replace(/\+/g, '\\+') + '):)');
      options = {
        name: name,
        regex: emojiRegex,
        replace: function replace(match) {
          return '<i class="e1a-' + match.slice(1, -1) + '"></i>';
        }
      };
      break;
    case 'font-awesome':
      var faIcons = [];
      _fontAwesomeIconChars2.default.forEach(function (char) {
        faIcons = faIcons.concat(char.id).concat(char.aliases || []);
      });
      var faRegex = new RegExp('(:fa-(?:' + faIcons.join('|') + '):)');
      options = {
        name: name,
        regex: faRegex,
        replace: function replace(match) {
          return '<i class="fa ' + match.slice(1, -1) + '"></i>';
        }
      };
      break;
    default:
      return;
  }
  md.renderer.rules[options.name] = function (tokens, idx) {
    return (0, _markdownItRegex.rendererRule)(tokens, idx, options);
  };
  md.core.ruler.push(options.name, function (state) {
    (0, _markdownItRegex.coreRuler)(state, options);
  });
};

exports.default = iconsPlugin;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("markdown-it-regex");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("emojione/emoji.json");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("font-awesome-icon-chars");

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js